module.exports = __webpack_public_path__ + "static/media/footprint3.20384d2d.png";